// src/components/Can.jsx
import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { pode } from "../utils/permissoes";

/**
 * Gate de permissão para UI:
 * - Se não tiver permissão, não renderiza (esconde botões/ações/trechos).
 *
 * Uso:
 * <Can modulo="cadastros" recurso="maquinas" acao="form">
 *   <button>+ Nova</button>
 * </Can>
 */
export function Can({ modulo, recurso, acao, children, fallback = null }) {
  const { usuario: usuarioLogado } = useAuth();
  const ok = pode(usuarioLogado, modulo, recurso, acao);
  return ok ? <>{children}</> : fallback;
}
